import { MantineThemeOverride } from '@mantine/core';

export type LoaderTheme = NonNullable<MantineThemeOverride['components']>['Loader'];

export const Loader: LoaderTheme = {
  // todo: define
};
